module.exports = __webpack_public_path__ + "static/esg-logo-f22df414211a27547f0a3f7a93b0226a.png";